
export default function ParticiateCardLoading() {
    return (
        <div >
            <div className="bg-gray-4 p-4 rounded-lg">
                <div className="flex items-center ">
                    <div className="flex w-full justify-between w-full items-center">
                        <div className="w-full">
                            <p className="skeleton rounded-md w-[70%] h-2 mb-1.5"></p>
                            <h1 className=" skeleton w-[85%] rounded-md h-4 "></h1>
                        </div>
                    </div>
                </div>

                <div className="w-full h-px skeleton bg-white/08 self-stretch my-3"></div>

                <div>
                    <div className="flex items-center justify-between">
                        <p className={` flex items-center rounded-md  w-[65%] h-3 skeleton justify-center gap-1`}>

                        </p>

                        <div className={`flex rounded-full items-center w-1/6 skeleton h-3 gap-1`}>
                            <span className="text-white font-medium text-xs leading-130 text-right"></span>
                        </div>
                    </div>

                    <div className="h-2 w-full skeleton rounded-lg bg-white/08 self-stretch my-3">
                        <div className={`h-full w-full rounded-lg`} ></div>
                    </div>

                    <div className="flex-center-between">
                        <p className="text-xs rounded-md w-1/2 h-2 skeleton leading-130 font-normal text-gray-1"></p>
                        <p className="text-xs skeleton rounded-md w-1/4 h-3 text-white leading-130 font-medium text-right lowercase">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}